import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "home": "Home",
  "about": "About Us",
  "services": "Services",
  "doctors": "Doctors",
  "contact": "Contact",
   "department" :"Department"  ,
   "welcome": "Welcome to Natraj Hospital",
  "hero_subtitle": "Expert doctors and outstanding medical services",
  "book_appointment": "Book Appointment",
  // "services_title": "Our Services",
  // "services_desc": "At Natraj Hospital, we offer a variety of medical services to meet all your health needs.",
  "emergency_service": "Emergency Service",
  "general_medicine": "General Medicine",
  "cardiology": "Cardiology",
  "nursing_care": "Nursing Care",
  "diagnostics_xray": "Diagnostics / X-Ray",
  "vaccination_services": "Vaccination Services",
  
  
    "about_title": "About Natraj Hospital",
    "about_detailed": "Welcome to <strong>Natraj Hospital, Bijoliya (Rajasthan)</strong>!<br><br>Our mission is to provide exceptional and accessible healthcare services to everyone. With a team of experienced doctors and trained staff, we focus on each patient's well-being.<br><br>We offer advanced medical facilities and personalized care to ensure the best treatment for every patient. At Natraj Hospital, we believe that every life is precious, and we are dedicated to inspiring healthier lives.<br><br><strong>Our Services:</strong><ul><li>Expert Doctors</li><li>Primary and Secondary Medical Care</li><li>Surgical and Operation Theatre Facilities</li><li>Women and Child Healthcare</li><li>Diagnostic Lab and Imaging Services</li></ul><br><strong>Our Mission:</strong><br>To provide world-class healthcare services to every citizen, contributing not only to the treatment of diseases but also to overall health improvement.",
    "our_doctors": "Meet Our Doctors",
  
  

"about_desc": "Natraj Hospital is a leading multispeciality hospital in Kota with advanced facilities and experienced doctors.",
"services_title": "Our Services",
"services_desc": "We offer a wide range of healthcare services to meet your complete medical needs.",
"banner1_title": "Welcome to Natraj Hospital",
"banner1_subtitle": "Team of skilled doctors and excellent medical services",
"banner1_button": "Book Appointment",

"banner2_title": "24x7 Emergency Services",
"banner2_subtitle": "Always at your service, anytime, anywhere",
"banner2_button": "Emergency Call",

"banner3_title": "We are a part of your health journey",
"banner3_subtitle": "Trusted care with advanced medical technology",
"banner3_button": "Learn More",
"facilities_title": "Services",
"facilities_list": {
  "icu": "24x7 ICU Facility",
  "lab": "Modern Pathology Lab",
  "pharmacy": "In-House Pharmacy",
  "opd": "OPD Services",
  "wards": "Hygienic Wards",
  "experts": "Expert Doctor Team"
},

"departments": {
    "heading": "Departments",
    "description": "We offer expertise in all major medical departments so you receive comprehensive healthcare in one place.",
    "list": [
      "Pediatrics",
      "Cardiology",
      "Nursing Care",
      "Neurology",
      "Pulmonary & Respiratory",
      "Dental Care"
    ]
  },
  "contactus": {
    "title": "Contact Us",
    "addressTitle": "Our Address",
    "address":"Bijolian, Bhilwara - 311602\nNear Teja Ji Ka Chowk",
    "phoneTitle": "Phone",
    "phone": "+91 7976336371\n+91 8696767267",
    "emailTitle": "Email",
    "email": "contact@natrajhospital.com",
    "form": {
      "name": "Your Name",
      "email": "Your Email",
      "message": "Write your message",
      "submit": "Submit"
    }
  },
            "jobs":"Jobs",

   "slidingMessage": "Welcome to Natraj Hospital Bijolia! Quality Healthcare | Experienced Doctors | Modern Facilities | 24x7 Emergency",
  "testimonial": {
    "title": "Patient Testimonials",
    "name1": "Ram Singh",
    "review1": "I felt very comfortable during my treatment at Natraj Hospital. The doctors and nurses were very supportive.",
    "name2": "Geeta Devi",
    "review2": "The services here are excellent. The doctor understood my illness properly and treated it well.",
    "name3": "Arun Kumar",
    "review3": "Very wonderful experience. The hospital environment was peaceful and comforting. I really liked the services here."
  },
  "gallery":{
   "title": "Hospital Gallery"

  },
  "doctorsname": [
    {
      "name": "Dr. Durgashankar Meher",
      "title": "M.B.B.S."
    },
    {
      "name": "Dr. Chandra Shekhar Meher",
      "title": "M.D."
    },
  ]

// "about_title": "About Us",
//   "about_detailed": "Welcome to Natraj Hospital, Bijolia (Rajasthan)! Our aim is to provide every individual with excellent and accessible healthcare services. Our hospital offers high-quality medical facilities, experienced doctors, and trained staff who take special care of each patient's health.<br/><br/>We have state-of-the-art technological facilities, experienced physicians, and a dedicated medical team that ensures timely diagnosis and treatment of various diseases. At Natraj Hospital, we believe that every life is precious, and therefore, we inspire patients towards a healthier life with superior care.<br/><br/><span class='font-semibold text-purple-700'>Our Services:</span><br/>• Team of Specialist Doctors<br/>• Primary and Secondary Medical Care<br/>• Surgical and Operation Theater Facilities<br/>• Women's and Children's Healthcare Services<br/>• Diagnostic Lab and Imaging Facilities<br/><br/><span class='font-semibold text-purple-700'>Our Mission:</span><br/>Natraj Hospital's mission is to provide world-class medical services to every citizen, not just treating illnesses but contributing towards complete health improvement."

    }
    
  },
  hi: {
    translation: 
      {
        
          "home": "होम",
          "about": "हमारे बारे में",
          "services": "सेवाएँ",
          "doctors": "डॉक्टर्स",
          "contact": "संपर्क करें ",
          "department":"विभाग",
         
          "welcome": "नटराज अस्पताल में आपका स्वागत है",
          "hero_subtitle": "कुशल डॉक्टरों की टीम और उत्कृष्ट चिकित्सा सेवाएं",
          "book_appointment": "अपॉइंटमेंट बुक करें",
          
       "about_title": "नटराज हॉस्पिटल के बारे में",
  "about_detailed": "नटराज हॉस्पिटल, बिजोलिया (राजस्थान) में आपका स्वागत है!<br><br>हमारा उद्देश्य है प्रत्येक व्यक्ति को उत्कृष्ट और सुलभ स्वास्थ्य सेवाएं प्रदान करना। हमारे हॉस्पिटल में उच्च गुणवत्ता वाली स्वास्थ्य सुविधाएं, अनुभवी डॉक्टरों और प्रशिक्षित स्टाफ द्वारा दी जाती हैं, जो हर मरीज की सेहत का विशेष ध्यान रखते हैं।<br><br>हमारे पास अत्याधुनिक तकनीकी सुविधाएं, अनुभवी चिकित्सक, और समर्पित चिकित्सा कर्मचारी हैं, जो विभिन्न बीमारियों का सही समय पर निदान और उपचार सुनिश्चित करते हैं। नटराज हॉस्पिटल में हम मानते हैं कि हर जीवन अनमोल है, और इसलिए हम उच्च स्तरीय देखभाल के साथ-साथ मरीजों को स्वस्थ जीवन की दिशा में प्रेरित करते हैं।<br><br><strong>हमारी सेवाएं:</strong><ul><li>विशेषज्ञ डॉक्टरों की टीम</li><li>प्राथमिक और द्वितीयक चिकित्सा उपचार</li><li>सर्जरी और ऑपरेशन थियेटर सुविधाएं</li><li>महिला एवं बाल चिकित्सा सेवाएं</li><li>डायग्नोस्टिक लैब और इमेजिंग सुविधाएं</li></ul><br><strong>हमारा मिशन:</strong><br>हर नागरिक को विश्वस्तरीय चिकित्सा सेवाएं उपलब्ध कराना, जिससे न केवल बीमारी का इलाज हो, बल्कि सम्पूर्ण स्वास्थ्य सुधार की दिशा में योगदान दिया जा सके।",
  "our_doctors": "हमारे डॉक्टरों से मिलें",

"about_desc": "नटराज अस्पताल कोटा का एक प्रमुख मल्टीस्पेशलिटी अस्पताल है, जहाँ उन्नत सुविधाएं और अनुभवी चिकित्सक उपलब्ध हैं।",
// "services_title": "हमारी सेवाएं",
// "services_desc": "नटराज अस्पताल में हम विभिन्न प्रकार की चिकित्सा सेवाएं प्रदान करते हैं जो आपकी संपूर्ण स्वास्थ्य आवश्यकताओं को पूरा करती हैं।",
"banner1_title": "नटराज अस्पताल में आपका स्वागत है",
  "banner1_subtitle": "कुशल डॉक्टरों की टीम और उत्कृष्ट चिकित्सा सेवाएं",
  "banner1_button": "अपॉइंटमेंट बुक करें",
  
  "banner2_title": "24x7 इमरजेंसी सेवा",
  "banner2_subtitle": "कभी भी, कहीं भी आपकी सेवा में",
  "banner2_button": "आपातकालीन कॉल",
  
  "banner3_title": "हम आपकी स्वास्थ्य यात्रा का हिस्सा हैं",
  "banner3_subtitle": "उन्नत चिकित्सा तकनीकों के साथ भरोसेमंद देखभाल",
  "banner3_button": "और जानें",
  "services_title": "हमारी सेवाएं",
  "services_desc": "नटराज अस्पताल में हम विभिन्न प्रकार की चिकित्सा सेवाएं प्रदान करते हैं जो आपकी संपूर्ण स्वास्थ्य आवश्यकताओं को पूरा करती हैं।",
  "emergency_service": "इमरजेंसी सेवा",
  "general_medicine": "जनरल मेडिसिन",
  "cardiology": "कार्डियोलॉजी",
  "nursing_care": "नर्सिंग केयर",
  "diagnostics_xray": "डायग्नोस्टिक्स / एक्स-रे",
  "vaccination_services": "टीकाकरण सेवाएं",
  "facilities_title": "सुविधाएं",
  "facilities_list": {
    "icu": "24x7 ICU सुविधा",
    "lab": "आधुनिक पैथोलॉजी लैब",
    "pharmacy": "इन-हाउस फ़ार्मेसी",
    "opd": "OPD सेवाएं",
    "wards": "हाईजीनिक वार्ड्स",
    "experts": "विशेषज्ञ डॉक्टर टीम"
  },
  
  "departments": {
    "heading": "विभाग",
    "description": "हम सभी प्रमुख चिकित्सा विभागों में विशेषज्ञता प्रदान करते हैं ताकि आपको एक ही स्थान पर संपूर्ण स्वास्थ्य देखभाल मिल सके।",
    "list": [
      "बाल रोग विभाग (Pediatrics)",
      "हृदय रोग (Cardiology)",
      "नर्सिंग केयर",
      "न्यूरोलॉजी",
      "फेफड़े एवं श्वसन विभाग",
      "डेंटल केयर"
    ]
  },
  "jobs":"रोज़गार",
    "slidingMessage": "नटराज हॉस्पिटल बिजोलिया में आपका स्वागत है! उत्कृष्ट स्वास्थ्य सेवा | अनुभवी डॉक्टर | आधुनिक सुविधाएं | 24x7 आपातकालीन सेवा",
// 
    "contactus": {
      "title": "संपर्क करें",
      "addressTitle": "हमारा पता",
      "address": "बिजौलिया, भीलवाड़ा - 311602\nतेजा जी का चौराहा के पास",
      "phoneTitle": "संपर्क नंबर",
      "phone": "+91 7976336371\n+91 8696767267",
      "emailTitle": "ईमेल",
      "email": "contact@natrajhospital.com",
      "form": {
        "name": "आपका नाम",
        "email": "आपका ईमेल",
        "message": "संदेश लिखें",
        "submit": "सबमिट करें"
      }
    },
    "testimonial": {
      "title": "मरीजों की राय",
      "name1": "राम सिंह",
      "review1": "नटराज अस्पताल में इलाज के दौरान मैं बहुत सहज महसूस कर रहा था। डॉक्टर और नर्स बहुत सहायक थे।",
      "name2": "गीता देवी",
      "review2": "यहाँ की सेवाएँ उत्कृष्ट हैं। डॉक्टर ने मेरी बीमारी को सही तरीके से समझा और उपचार किया।",
      "name3": "अरुण कुमार",
      "review3": "बेहद शानदार अनुभव। अस्पताल का वातावरण बहुत शांत और आरामदायक था। मुझे यहां की सेवाएँ बहुत पसंद आईं।"
    },
"gallery":{
    "title": "अस्पताल गैलरी"

},
"doctorsname": [
  {
    "name": "डॉ. दुर्गाशंकर मेहर",
    "title": "एम.बी.बी.एस"
  },
  {
    "name": "डॉ. चंद्र शेखर मेहर",
    "title": "एम.डी."
  },
]
// "about_title": "हमारे बारे में",
//   "about_detailed": "नटराज हॉस्पिटल, बिजोलिया (राजस्थान) में आपका स्वागत है! हमारा उद्देश्य है प्रत्येक व्यक्ति को उत्कृष्ट और सुलभ स्वास्थ्य सेवाएं प्रदान करना। हमारे हॉस्पिटल में उच्च गुणवत्ता वाली स्वास्थ्य सुविधाएं, अनुभवी डॉक्टरों और प्रशिक्षित स्टाफ द्वारा दी जाती हैं, जो हर मरीज की सेहत का विशेष ध्यान रखते हैं।<br/><br/> हमारे पास अत्याधुनिक तकनीकी सुविधाएं, अनुभवी चिकित्सक, और समर्पित चिकित्सा कर्मचारी हैं, जो विभिन्न बीमारियों का सही समय पर निदान और उपचार सुनिश्चित करते हैं। नटराज हॉस्पिटल में हम मानते हैं कि हर जीवन अनमोल है, और इसलिए हम उच्च स्तरीय देखभाल के साथ-साथ मरीजों को स्वस्थ जीवन की दिशा में प्रेरित करते हैं।<br/><br/><span class='font-semibold text-purple-700'>हमारी सेवाएं:</span><br/>• विशेषज्ञ डॉक्टरों की टीम<br/>• प्राथमिक और द्वितीयक चिकित्सा उपचार<br/>• सर्जरी और ऑपरेशन थियेटर सुविधाएं<br/>• महिला एवं बाल चिकित्सा सेवाएं<br/>• डायग्नोस्टिक लैब और इमेजिंग सुविधाएं<br/><br/><span class='font-semibold text-purple-700'>हमारा मिशन:</span><br/>नटराज हॉस्पिटल का मिशन है हर नागरिक को विश्वस्तरीय चिकित्सा सेवाएं उपलब्ध कराना, जिससे न केवल बीमारी का इलाज हो, बल्कि सम्पूर्ण स्वास्थ्य सुधार की दिशा में योगदान दिया जा सके।"


 
      }
      
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "hi", // default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  
});


export default i18n;
